import { CREATE_AVATAR_IMAGE, DELETE_AVATAR_IMAGE } from "../graphql/mutation";
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { actionTypes, AvatarImageProps } from "./actionType";
import { showSnackbar } from "utils/snack_bar/store/action";
import { FETCH_AVATAR } from "../graphql/query";

export const fetchAvaterImageRequest = () => ({
  type: actionTypes.FETCH_AVATAR_IAMGE_REQUEST,
});

export const fetchAvaterImageSuccess = (payload: AvatarImageProps[]) => ({
  type: actionTypes.FETCH_AVATAR_IAMGE_SUCCESS,
  payload,
});

export const fetchAvaterImageFail = (payload: string) => ({
  type: actionTypes.FETCH_AVATAR_IAMGE_FAIL,
  payload,
});

export const fetchAvaterImage = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchAvaterImageRequest());
      const response = await executeQuery(FETCH_AVATAR);
      const jsonData = response.data?.fetchAvatar;
      if (jsonData?.error === null) {
        dispatch(fetchAvaterImageSuccess(jsonData?.data.avatars));
      } else {
        dispatch(fetchAvaterImageFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchAvaterImageFail("Failed to fetch Groups(s)"));
    }
  };
};

export const createAvaterImageRequest = () => ({
  type: actionTypes.CREATE_AVATAR_IAMGE_REQUEST,
});
export const createAvaterImageSuccess = (payload: AvatarImageProps) => ({
  type: actionTypes.CREATE_AVATAR_IAMGE_SUCCESS,
  payload,
});
export const createAvaterImageFail = (payload: string) => ({
  type: actionTypes.CREATE_AVATAR_IAMGE_FAIL,
  payload,
});

export const createAvaterImage = (avatar_image_url:string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(createAvaterImageRequest());
      const response = await executeMutation(CREATE_AVATAR_IMAGE,{ avatar_image_url });
      const jsonData = response.data?.createAvatar;
      if (jsonData?.error === null) {
        dispatch(createAvaterImageSuccess(jsonData?.data.group));
        dispatch(showSnackbar("Success! Avatar image created."));
      } else {
        dispatch(createAvaterImageFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(createAvaterImageFail("Something went wrong, please try again"));
    }
  };
};

//DeleteAvatarImage
export const deleteAvaterImageRequest = () => ({
  type: actionTypes.DELETE_AVATAR_IAMGE_REQUEST,
});
export const deleteAvaterImageSuccess = (payload: string) => ({
  type: actionTypes.DELETE_AVATAR_IAMGE_SUCCESS,
  payload,
});
export const deleteAvaterImageFail = (payload: string) => ({
  type: actionTypes.DELETE_AVATAR_IAMGE_FAIL,
  payload,
});

export const deleteAvaterImage = (avatar_id:string) => {
  return async (dispatch: any) => {
    try {
      await dispatch(deleteAvaterImageRequest());
      const response = await executeMutation(DELETE_AVATAR_IMAGE,{ avatar_id });
      const jsonData = response.data?.deleteAvatar;
      if (jsonData?.error === null) {
        dispatch(deleteAvaterImageSuccess(avatar_id));
        dispatch(showSnackbar("Success! Avatar image deleted."));
      } else {
        dispatch(deleteAvaterImageFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(deleteAvaterImageFail("Something went wrong, please try again"));
    }
  };
};
